import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Avatar } from "@mui/material";
import "./LeaveAdvanceEncashmentARModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import CompDirection from "../../../themes/CompDirection";
import { themes } from "../../../themes/themes";
import TakeActionSplitBtn from "../../../components/TakeActionSplitBtn/TakeActionSplitBtn";
import HorizontalStepperForActionRequired from "../../../components/HorizontalStepperForActionRequired/HorizontalStepperForActionRequired";
import { DateField } from "../../../../components";
import { baseDateFormatting } from "../../../helper";
import LeaveHistoryArTile from "../../../components/LeaveHistoryTileAr/LeaveHistoryTileAr";
import moment from "moment";
import LeaveAppliedContent from "../../../components/LeaveAppliedContent/LeaveAppliedContent";
import { useTranslate } from "../../../../hooks";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  full_data: any;
  trans?: any;
  leaveActions?: any;
  userId?: any;
  handleSubmitAR_Request?: any;
  historyData?: any;
}

const LeaveAdvanceEncashmentARModalPresenter = ({
  isModalOpen,
  closeModal,
  full_data,
  trans,
  leaveActions,
  userId,
  handleSubmitAR_Request,
  historyData
}: ModalProps) => {

  const {translate} = useTranslate()

  const handleTakeAction = (x: any, event: string) => {
    if (x) {
      const payload = {
        event: event,
        instanceId: full_data?.id,
        action: x ? x : '',
        model: 'leave_encashment',
        userId: userId,
        context: {
          employee_type: full_data.employee_type,
          employee_category: full_data.employee_category,
        },
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };

  const status = ['Pending','Approved','Rejected','Cancelled']

  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="40vw">
      <ModalHeader
        modal={{
          modal_title: trans("Leave Encashment Action Required"),
        }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "5px",
          }}
        >
          <Grid item xs={6}>
            <Box className="bg_border_ar">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Avatar />
                <Box style={{ paddingLeft: "10px" }}>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      color: themes.darkBlue,
                      fontSize: "1em",
                      fontWeight: "bold",
                    }}
                  >
                    {full_data?.first_name + " " + full_data?.last_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      color: themes.grey_colorDesignationAR,
                      fontSize: "0.825em",
                    }}
                  >
                    {full_data?.department_name}/{full_data?.designation_name}
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    From
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    <DateField 
                    value={full_data?.start_date}
                    format={baseDateFormatting}
                    offset={0}
                    />
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    To
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    <DateField 
                    value={full_data?.end_date}
                    format={baseDateFormatting}
                    offset={0}
                    />
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    Days
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    {full_data?.total_leave_days}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    Amount
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    {full_data?.amount}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    Attachment
                  </Typography>
                  <Box>
                    <i className="las la-eye" color={themes.primary} />
                  </Box>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  marginTop: "0.5em",
                  width: "auto",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: themes.defaultScondary_blue,
                  }}
                >
                  Remarks
                </Typography>
                <Typography
                  style={{
                    fontFamily: "Lato",
                    fontSize: "12px",
                    color: themes.greyModalTitle,
                  }}
                >
                  {full_data?.remark}
                </Typography>
              </Box>
              <Box style={{ marginTop: "1.5em" }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: "1.5em", zIndex: "999", width: "100%" }}>
                <TakeActionSplitBtn
                  menu={leaveActions}
                  title={"Take Action"}
                  onAction={(x:any)=>{handleTakeAction(x,"leave encashment")}}
                />
              </Box>
            </Box>
          </Grid>

          {/* {Horizontals Steps Label} */}
          <Grid item xs={4}>
            <Box className="bg_border_ar">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.primaryMain,
                    fontSize: '0.875em',
                    fontWeight: 'bold',
                  }}
                >
                  Leave History
                </Typography>
              </Box>
              {historyData?.length > 0 &&
                historyData.map((leave: any) => {
                  return (
                    <div key={leave.id}>
                      <LeaveHistoryArTile
                        actorName=""
                        date1={moment(leave?.start_date).format('DD MMM, YYYY')}
                        date2={moment(leave?.end_date).format('DD MMM, YYYY')}
                        dayOrAmount={leave?.total_leave_days}
                        remarks={leave?.remark}
                        status={status[leave?.status]}
                        typeName={leave?.leave_type?.name}
                      />
                    </div>
                  );
                })}
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default LeaveAdvanceEncashmentARModalPresenter;
